"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Step", {
  enumerable: true,
  get: function get() {
    return _Step["default"];
  }
});
exports["default"] = void 0;

var _Steps = _interopRequireDefault(require("./Steps"));

var _Step = _interopRequireDefault(require("./Step"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Steps["default"].Step = _Step["default"];
var _default = _Steps["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-steps/lib/index.js
// module id = 1850
// module chunks = 0